define([
        'text!./../views/landingpage1.html',
        'text!./../views/landingpage2.html',
        'text!./../views/loadinglandingpage.html',
        '../controllers/LoadingLandingPageCtrl',
        '../controllers/LandingPageCtrl',
        'text!../config/landingPage1Content.json'
    ],
    (landingPage1View, landingPage2View, loadingLandingPage, LoadingLandingPageCtrl, LandingPageCtrl,
     landingPage1Content) => {
        return {
            landingPage1: {
                url: '/lp1',
                template: landingPage1View,
                controller: LandingPageCtrl,
                resolve: {
                    landingPageContent: ()=> JSON.parse(landingPage1Content)
                }
            },

            landingPage2: {
                url: '/lp2',
                template: landingPage2View,
                controller: LandingPageCtrl,
                resolve: {
                    landingPageContent: ()=> {
                    }
                }
            },

            loadingLandingPage: {
                controller: LoadingLandingPageCtrl,
                url: '/loading',
                template: loadingLandingPage,
                params: {
                    params: null
                }
            }
        };
    });



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/segmentation/demolandingpage/config/RouteConfig.js